export { default } from './SingleChoice';
